const auth0 = require('auth0-js')

export const auth = new auth0.WebAuth({
    domain: process.env.REACT_APP_AUTH0_DOMAIN,
    clientID: process.env.REACT_APP_AUTH_CLIENT_ID,
    scope: 'openid email profile',
    audience: 'https://dev-17rgvsw56obqvxnk.us.auth0.com/api/v2/'
});